import React from "react";
import CEAFTable from "./CEAFTable/CEAFTable";

export default function CEAFCard(props) {
    const { ceaf_data } = props
    const hasSource = Object.keys(ceaf_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                CEAF - Match encontrado
            </p>
            <CEAFTable ceaf_data={ceaf_data.source} />
        </div>
    )
}
